module.exports = __webpack_public_path__ + "static/img/wechatDot2@3x41551f5.png";